import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useNavContext } from "../../context/nav_context";
import { api_v3_user_detail_update } from "../../utils/constants";

const RegisterStreamerTournamentOk = ({ tournamentId }) => {
  const { user, accessToken, refreshUser } = useNavContext();
  const [dataComplete, setDataComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const socialMediaInfo = user?.socialMedia || [];
  const twitchInfo = socialMediaInfo.find((sm) => sm.platform === "twitch");
  const youtubeInfo = socialMediaInfo.find((sm) => sm.platform === "youtube");

  const [twitchUrl, setTwitchUrl] = useState(twitchInfo?.link || "");
  const [youtubeUrl, setYoutubeUrl] = useState(youtubeInfo?.link || "");

  const handleUpdateUserDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = accessToken || localStorage.getItem("access_token");
      const socialMedia = [
        { platform: "twitch", link: twitchUrl },
        { platform: "youtube", link: youtubeUrl },
      ];
      const res = await axios.post(
        api_v3_user_detail_update(),
        { ...user, socialMedia },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.status === 200) {
        refreshUser();
        setDataComplete(true);
      }
    } catch {
      setError("Hubo un error al actualizar los datos. Por favor, intenta nuevamente.");
    }
    setLoading(false);
  };

  if (!user) {
    return (
      <Card>
        <CardTitle>REGISTRADO, PERO...</CardTitle>
        <BodyText>
          Estás registrado en el torneo, pero es posible que nos falte algún dato
          ya que hemos tenido un problema validando tus datos. En los próximos días
          la organización revisará tus datos y si falta algo nos pondremos en contacto
          contigo. Si no te decimos nada, todo está bien.
        </BodyText>
        <OutlineBtn to={`/register/tournament/${tournamentId}`}>REINTENTAR REGISTRO</OutlineBtn>
      </Card>
    );
  }

  if (!dataComplete) {
    return (
      <Card>
        <CardTitle>TUS REDES</CardTitle>
        <BodyText>Opcional: añade los enlaces a tus canales para que los jugadores te encuentren.</BodyText>

        <Field>
          <Label htmlFor="twitch">TWITCH</Label>
          <Input
            id="twitch"
            type="text"
            placeholder="https://www.twitch.tv/tu_canal"
            value={twitchUrl}
            onChange={(e) => setTwitchUrl(e.target.value)}
          />
        </Field>
        <Field>
          <Label htmlFor="youtube">YOUTUBE</Label>
          <Input
            id="youtube"
            type="text"
            placeholder="https://www.youtube.com/tu_canal"
            value={youtubeUrl}
            onChange={(e) => setYoutubeUrl(e.target.value)}
          />
        </Field>

        {error && <ErrorText>{error}</ErrorText>}

        <MintBtn onClick={handleUpdateUserDetails} disabled={loading}>
          {loading ? "GUARDANDO..." : "GUARDAR Y COMPLETAR"}
        </MintBtn>
      </Card>
    );
  }

  return (
    <Card>
      <CardTitle>¡ESTÁS INSCRITO!</CardTitle>
      <BodyText>
        Muchas gracias! Acuérdate de apuntar en los partidos que vas a stremear
        para que llegue a todos.
      </BodyText>
      <OutlineBtn to="/">VOLVER A LA HOME</OutlineBtn>
    </Card>
  );
};

const Card = styled.div`background: var(--v-surface); border: 1px solid rgba(255,255,255,0.06); border-radius: 20px; padding: 2rem; margin-bottom: 1.25rem;`;
const CardTitle = styled.h3`font-family: var(--v-font-mono); font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; color: var(--v-fg-muted); margin: 0 0 1rem;`;
const BodyText = styled.p`font-family: var(--v-font-body); font-size: 14px; line-height: 1.6; color: var(--v-fg); margin: 0 0 1.5rem;`;

const Field = styled.div`margin-bottom: 1rem;`;
const Label = styled.label`display: block; font-family: var(--v-font-mono); font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: var(--v-fg-muted); margin-bottom: 0.4rem;`;
const Input = styled.input`width: 100%; padding: 0.6rem 0.75rem; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; color: var(--v-fg); font-family: var(--v-font-body); font-size: 14px; outline: none; transition: border-color 0.15s ease; box-sizing: border-box; &:focus { border-color: var(--v-mint); } &::placeholder { color: rgba(255,255,255,0.2); }`;

const ErrorText = styled.p`font-family: var(--v-font-body); font-size: 12px; color: #ff3b3b; margin: 0 0 1rem;`;

const MintBtn = styled.button`background: var(--v-mint); border: none; color: #000; font-family: var(--v-font-mono); font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; padding: 0.6rem 1.5rem; border-radius: 24px; cursor: pointer; transition: opacity 0.15s ease; &:hover { opacity: 0.85; } &:disabled { opacity: 0.5; cursor: not-allowed; }`;

const OutlineBtn = styled(Link)`display: inline-flex; align-items: center; padding: 0.5rem 1.25rem; border: 1px solid rgba(255,255,255,0.15); border-radius: 24px; color: var(--v-fg); font-family: var(--v-font-mono); font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; text-decoration: none; transition: border-color 0.15s ease; &:hover { border-color: var(--v-mint); }`;

export default RegisterStreamerTournamentOk;
